// extracted by mini-css-extract-plugin
export default {"achorButton":"TrackedAnchorButton_achorButton__x-8mR"};